import React from 'react';
import { CheckupRequestInfo } from '@companion-professional/dctypes';
import { ChevronsRight } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

import { Card } from '@companion-professional/components';
import { Markdown } from '@companion-professional/components/Markdown';
import { NeedHelpContactSupport } from '../../../../components/NeedHelpContactSupport';
import { PrimaryActionButton } from '../../../../components/PrimaryActionButton';
import BasePage from '../../base/BasePage';

interface StdLanderBaseProps {
  pageKind: string;
  defn: {
    lander_description: string;
    button_text: string;
  };
  checkupRequest: CheckupRequestInfo;
  page: number;
  media: React.ReactNode;
}

export const StdLanderBase = ({ pageKind, defn, checkupRequest, page, media }: StdLanderBaseProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <BasePage
      page={page}
      pageKind={pageKind}
      checkupRequest={checkupRequest}
      renderChild={() => (
        <div className="vertically-spaced-content">
          {media}
          <Card className="mx-4 justify-start p-2">
            {/*
              TODO: For some reason TypeScript thinks defn.lander_description is an **array** of strings, not just a
              string. See https://app.clickup.com/t/868f8jxgz.
            */}
            <Markdown>{(defn.lander_description || "") as string}</Markdown>
          </Card>
          <div className="space-y-2 px-4">
            <PrimaryActionButton
              onClick={() => {
                const pathSegments = location.pathname.split('/').filter(Boolean);
                const lastSegment = pathSegments[pathSegments.length - 1];
                // If the last segment matches our current page number, replace it; otherwise append. We do this because
                // the URLs in vportal and that we send to users are just /checkup_id without a page number so no page
                // number corresponds to page 0.
                navigate(lastSegment === String(page) ? `../${page + 1}` : `./${page + 1}`);
              }}
            >
              {defn.button_text} <ChevronsRight size="24" />
            </PrimaryActionButton>
            <NeedHelpContactSupport />
          </div>
        </div>
      )}
    />
  );
};
